"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createOncologyDiseases = createOncologyDiseases;
const utils_1 = require("../../../events/utils");
const shared_1 = require("../../shared");
const queries_1 = require("../queries");
const oncologyDiseases_1 = require("../../../forms/ktx/transplantation-screening/medical-history/oncologyDiseases");
const messages = {
    title: {
        id: "ktx.dashboard.oncology_diseases",
        defaultMessage: "Onkológiai betegségek"
    },
    t: {
        id: "ktx.dashboard.oncology_diseases.t",
        defaultMessage: "T"
    },
    n: {
        id: "ktx.dashboard.oncology_diseases.n",
        defaultMessage: "N"
    },
    m: {
        id: "ktx.dashboard.oncology_diseases.m",
        defaultMessage: "M"
    },
    treatment: {
        id: "ktx.dashboard.oncology_diseases.treatment",
        defaultMessage: "Kezelése"
    }
};
function createOncologyDiseases(intl, options) {
    const lists = createList(intl, options);
    const content = (0, shared_1.createGroupContent)(lists);
    return (0, shared_1.createGroup)(intl, { label: messages.title, content });
}
function createList({ formatMessage, formatMessageMap, formatDate }, { events }) {
    const relevantEvents = (0, utils_1.findEventsByQuery)(events, queries_1.medicalHistoryQueries.oncologyDiseases);
    return relevantEvents
        .map(event => {
        const { timestamp, origin } = event;
        const formattedTimestamp = formatDate(timestamp, {
            year: "numeric",
            month: "numeric",
            day: "numeric"
        });
        let label = "";
        const items = [];
        if (typeof event.value === "string") {
            items.push({
                type: "list-item",
                value: formatMessageMap(oncologyDiseases_1.hasDiseaseMessages, event.value)
            });
            label = `${formattedTimestamp}`;
        }
        else {
            const treatments = event.value.treatment
                ? event.value.treatment
                    .map(t => formatMessageMap(oncologyDiseases_1.treatmentMessages, t))
                    .join(", ")
                : "";
            items.push({
                type: "list-item",
                label: formatMessage(messages.t),
                value: formatMessageMap(oncologyDiseases_1.tumourMessages, event.value.grade.tumour)
            }, {
                type: "list-item",
                label: formatMessage(messages.n),
                value: formatMessageMap(oncologyDiseases_1.nodesMessages, event.value.grade.nodes)
            }, {
                type: "list-item",
                label: formatMessage(messages.m),
                value: formatMessageMap(oncologyDiseases_1.metastasesMessages, event.value.grade.metastases)
            }, {
                type: "list-item",
                label: formatMessage(messages.treatment),
                value: treatments
            });
            label = `${formattedTimestamp} - ${formatMessageMap(oncologyDiseases_1.typeMessages, event.value.type)}`;
        }
        return {
            type: "list",
            attachments: (0, utils_1.mapEventsToAttachments)(event),
            timestamp: event.timestamp,
            label,
            origin,
            items
        };
    })
        .sort(shared_1.compareByTimestamp);
}
